(function (upp) {
    'use strict';

    RegisterFieldsController.$inject = [ '$scope', 'customerAccountService' ];
    function RegisterFieldsController($scope, customerAccountService) {
        Object.defineProperties(this, {
            email: { value: '', writable: true },
            name: { value: '', writable: true },
            password: { value: '', writable: true },
            surname: { value: '', writable: true },
            fields: { value: [], writable: true },
            fieldValues: { value: [], writable: true },
            onChange: {
                enumerable: true,
                get: function() { return $scope.onChange || angular.noop },
            },
        });

        var fieldsSub = customerAccountService.fields$
            .subscribe(function(fields) {
                this.fields = fields;
                $scope.$evalAsync();
            }.bind(this));

        $scope.$on('$destroy', function() {
            fieldsSub.unsubscribe();
        });
    }

    RegisterFieldsController.prototype.onCustomerFieldsChange = function(fields) {
        Object.assign(this, {
            fieldValues: fields,
        });
        this.notifyChanges();
    }

    RegisterFieldsController.prototype.onPasswordChange = function(password) {
        Object.assign(this, {
            password: password,
        });
        this.notifyChanges();
    }

    RegisterFieldsController.prototype.notifyChanges = function() {
        this.onChange({
            $event: {
                email: this.email,
                password: this.password,
                name: this.name,
                surname: this.surname,
                fields: this.fieldValues,
            }
        });
    }

    upp.directive('registerFields', [ function () {
        return {
            restrict: 'E',
            scope: {
                onChange: '&?',
            },
            templateUrl: require('../templates/register-fields.html'),
            controllerAs: '$ctrl',
            controller: RegisterFieldsController,
        };
    } ]);

}(upp));



// WEBPACK FOOTER //
// ./src/app/modules/customer-account/component/register-fields.component.js